module.exports = __webpack_public_path__ + "img/course-1.e9591b3d.jpeg";